import LegalPageLayout from '@/components/feature/LegalPageLayout';

export default function PreInfoPage() {
  return (
    <LegalPageLayout title="Ön Bilgilendirme Formu">
      <p>6502 sayılı Tüketicinin Korunması Hakkında Kanun ve Mesafeli Sözleşmeler Yönetmeliği uyarınca, satın alma işlemi öncesinde alıcının bilgilendirilmesi amacıyla hazırlanmıştır.</p>

      <h4>1. Satıcı Bilgileri</h4>
      <p>
        <strong>Firma Adı:</strong> Atak Sistem Enerji<br />
        <strong>Telefon:</strong> 0266 246 41 59<br />
        <strong>Hizmet Bölgesi:</strong> Balıkesir ve Bölge İller
      </p>

      <h4>2. Sözleşme Konusu Ürün/Hizmetin Temel Özellikleri</h4>
      <p>Fineco Isı Pompası, kat kaloriferi ve güneş enerjisi sistemleri; ısıtma, soğutma ve enerji verimliliği odaklı ürün ve hizmetlerdir. Ürünün teknik özellikleri, kapasite bilgileri ve fiyatı sipariş aşamasında alıcıya bildirilecektir.</p>

      <h4>3. Ürün/Hizmetin Toplam Fiyatı</h4>
      <p>Ürün/hizmet bedeli, seçilen sisteme, kapasiteye, kurulum kapsamına ve bölgeye göre değişiklik göstermektedir. Kesin fiyat, ihtiyaç analizi sonrası alıcıya bildirilecektir.</p>

      <h4>4. Cayma Hakkı</h4>
      <p>Alıcı, 14 gün içinde herhangi bir gerekçe göstermeden ve cezai şart ödemeden sözleşmeden cayma hakkına sahiptir.</p>

      <h4>5. Yetkili Mahkeme</h4>
      <p>Uyuşmazlık durumunda Tüketici Hakem Heyetleri ve Tüketici Mahkemeleri yetkilidir.</p>

      <p>İşbu ön bilgilendirme formu, alıcı tarafından okunup anlaşıldıktan sonra satın alma işlemi gerçekleştirilecektir.</p>
    </LegalPageLayout>
  );
}